import { buildContentfulHooks } from 'services/ContentfulService/hooks/template'
import { Fact, FAQ, getFaqsFromFacts, parseFact } from 'services/ContentfulService/models/fact'
import { IFactFields } from 'generated/types/contentful'
import { getTopicById } from 'services/ContentfulService/hooks/topics'
import { ContentfulTopicIds, Product, ProductWithChildren } from 'services/ContentfulService/models/product'
import { Topic } from 'services/ContentfulService/models/topics'

export const [useFacts, useFactsSSR, factFetcher] = buildContentfulHooks<Fact, IFactFields>('fact', parseFact)

export const getFaqsByFionaTopic = async (): Promise<FAQ[]> => {
	const fionaTopic = await getTopicById(ContentfulTopicIds.Fiona)
	return fionaTopic.faqs!
}

export const getFaqsByProduct = async (product: ProductWithChildren | Product): Promise<FAQ[]> => {
	if (product.facts) {
		return getFaqsFromFacts(product.facts)
	} else {
		return []
	}
}

export const getFaqsByTopic = async (topic: Topic): Promise<FAQ[]> => {
	if (topic.faqs) {
		return topic.faqs
	} else {
		return []
	}
}
